The granted status of the degree.

Currently, two statuses are defined:

- `InProgress` indicates the student is still completing the degree.
- `Granted` indicates the degree has been granted to the student.
